import {Button} from "antd";
import styled from "styled-components";

export const StyledButton = styled(Button)`
    background-color: black;
    color: white;
    border: none;
    &:hover,
    &:focus,
    &:active {
        background-color: #4d4d4d;
        color: white;
    }
`;
